import { system } from 'styled-system';
import { getTextContrast } from '../utils';
const config = {
  backgroundColor: {
    property: 'color',
    scale: 'textContrast',
    transform: (value, scale, props) => getTextContrast(value, scale)(props)
  },
  color: {
    property: 'color',
    scale: 'palette'
  }
};
config.bg = config.backgroundColor;
export const textContrast = system(config);